/*---------------------------------------------------------------------------------------------
 *  Copyright (c) i-Bridge Systems Philippines Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/
import { ConfirmationModal, SuccessModal } from '../index';
import { useState } from 'react';
import { apiUrl } from '../../utilities/apiUrl';
import { DeleteForever } from '@mui/icons-material';
import { Box, Typography } from '@mui/material';

export const DeleteEmpModal = (props) => {
  const [deleteSuccessOpen, setDeleteSuccessOpen] = useState(false);

  // DELETE EMPLOYEE RECORD HANDLER
  const handleDelete = () => {
    props.handleDownloadEmployeePDF(props.selectedEmp);
    fetch(apiUrl('/employee/deleteall/' + props.selectedEmp), {
      method: 'DELETE',
      credentials: 'include',
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.success) {
          setDeleteSuccessOpen(true);
        } else {
          alert(data.message);
        }
      });
  };
  return (
    <>
      <ConfirmationModal
        open={props.open}
        onClose={props.onClose}
        primaryClickHandler={() => {
          handleDelete();
          props.onClose();
        }}
        secondaryClickHandler={props.onClose}
        title={
          <Box display="flex" alignItems="center" gap={1}>
            <DeleteForever sx={{ fontSize: 30 }} />
            <Typography
              variant="h6"
              fontWeight={600}
              sx={{ color: '#c53838ff' }}
            >
              Delete Employee
            </Typography>
          </Box>
        }
        desc={
          <Box>
            <Typography variant="body1" sx={{ mt: 3, mb: 2 }}>
              Are you sure you want to permanently delete:
            </Typography>
            <Typography
              variant="h6"
              fontWeight={700}
              color="#c53838ff"
              sx={{ mb: 5 }}
            >
              {props.deleteName}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              This action cannot be undone and the employee’s data will be
              permanently removed.
            </Typography>
          </Box>
        }
        primaryBtnName={'Delete'}
        secondaryBtnName={'Cancel'}
        primaryStyle={{
          bgcolor: '#d32f2f',
          border: '1px solid #d32f2f',
          '&:hover': {
            bgcolor: '#b71c1c !important',
            borderColor: '#b71c1c',
          },
        }}
      />
      <SuccessModal
        open={deleteSuccessOpen}
        onClose={() => {
          setDeleteSuccessOpen(false);
          props.resetIndex();
          window.location.reload();
        }}
        close={() => {
          setDeleteSuccessOpen(false);
          props.resetIndex();
          window.location.reload();
        }}
        desc={'You have successfully deleted an employee.'}
      />
    </>
  );
};
